import { requestApiPostNoContent } from "../api/BacklogApiEndpoint";
import type { BacklogConfig } from "../contracts/BacklogConfig";
import type { BacklogApiContext } from "../contracts/api/BacklogApiContext";
import type { BacklogResponse } from "../contracts/api/BacklogResponse";
import type { BacklogResponseNoContent } from "../contracts/api/BacklogResponseNoContent";
import { assert } from "../utils/BacklogUtil";
import type { AddStarParams } from "./params/AddStarParams";

/**
 * Add Star スターの追加
 *
 * Adds star.
 */
export function addStar(
	config: BacklogConfig,
	params: AddStarParams,
	context?: BacklogApiContext,
): Promise<BacklogResponse<BacklogResponseNoContent>> {
	assert(params);
	return requestApiPostNoContent({
		config,
		path: "stars",
		params,
		context,
	});
}
